const DEFAULT_AGE_LIMIT = 18;

export default {
  DEFAULT_AGE_LIMIT,
};
